import { render, staticRenderFns } from "./IrradianceGraph.vue?vue&type=template&id=4bd539bd&scoped=true&"
import script from "./IrradianceGraph.vue?vue&type=script&lang=js&"
export * from "./IrradianceGraph.vue?vue&type=script&lang=js&"
import style0 from "./IrradianceGraph.vue?vue&type=style&index=0&id=4bd539bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd539bd",
  null
  
)

export default component.exports